import { render, staticRenderFns } from "./GBrandEdit.vue?vue&type=template&id=b47ef354&scoped=true&"
import script from "./GBrandEdit.vue?vue&type=script&lang=ts&"
export * from "./GBrandEdit.vue?vue&type=script&lang=ts&"
import style0 from "./GBrandEdit.vue?vue&type=style&index=0&id=b47ef354&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b47ef354",
  null
  
)

export default component.exports